// extracted by mini-css-extract-plugin
module.exports = {"chooser":"components-LocationChooser-___LocationChooser__chooser___2LjLs"};